<template>
  <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
    <PageHeader
      :tagline="topic"
      :title="entity?.title || title"
      :lead="entity?.intro || intro"
      :inverted="hasBackground"
      :teaser-image="image"
    />
    <div class="page-content bg-gray-50">
      <BlokkliField :list="paragraphs" name="field_paragraphs" />
    </div>
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { NodeBlogFragment, MediaImageFragment } from '#graphql-operations'

const props = defineProps<{
  __typename?: string
  title?: string
  intro?: string
  teaserImage?: MediaImageFragment
  heroImage?: MediaImageFragment
  paragraphs?: NodeBlogFragment['paragraphs']
  blokkliProps: NodeBlogFragment['blokkliProps']
  hasBackground?: boolean
  pageColor?: NodeBlogFragment['pageColor']
  publishedAtDate?: NodeBlogFragment['publishedAtDate']
  referencedTopic?: NodeBlogFragment['referencedTopic']
  author?: NodeBlogFragment['author']
}>()

const topic = props.referencedTopic?.topiclabel || ''

const { hasBackground, htmlClasses } = usePageState(props)

const image = computed(() => props.heroImage)

useHead({
  htmlAttrs: {
    class: htmlClasses,
  },
})
</script>
